import { applyNewUiFromUrl } from "@/components/newUi/core/newUiPreference";

applyNewUiFromUrl();
